import React from 'react';
import ForgotPassword from '../features/auth/components/ForgotPassword';

const ForgotPasswordPage = () => {
  return <ForgotPassword />;
};

export default ForgotPasswordPage;
